export default function SkillsLearned() {
  const skills = [
    { icon: 'ri-user-heart-line', title: 'Быстро устанавливать контакт', desc: 'Первые 15 секунд определяют исход звонка. Учим начинать так, чтобы клиент захотел слушать дальше.' },
    { icon: 'ri-emotion-happy-line', title: 'Уверенно начинать разговор', desc: 'Без страха, без дрожи в голосе, без желания быстрее положить трубку.' },
    { icon: 'ri-shield-user-line', title: 'Проходить секретаря', desc: 'Выстраиваем доверительные отношения с помощниками, а не пытаемся их обмануть.' },
    { icon: 'ri-vip-crown-line', title: 'Выходить на ЛПР', desc: 'Учим находить и заинтересовывать лиц, принимающих решения, в компаниях любого размера.' },
    { icon: 'ri-star-line', title: 'Формулировать ценность', desc: 'Говорить о выгоде для клиента, а не о характеристиках продукта.' },
    { icon: 'ri-question-answer-line', title: 'Задавать сильные вопросы', desc: 'Вопросы, которые раскрывают потребность, а не ставят клиента в тупик.' },
    { icon: 'ri-shield-check-line', title: 'Работать с отказами', desc: 'Превращать «нет» и «нам неинтересно» в начало конструктивного диалога.' },
    { icon: 'ri-focus-2-line', title: 'Удерживать внимание клиента', desc: 'Техники, которые не дают клиенту «выпасть» из разговора на середине.' },
    { icon: 'ri-calendar-check-line', title: 'Договариваться о встрече', desc: 'Конкретная дата и время, а не «созвонимся на следующей неделе».' },
    { icon: 'ri-heart-pulse-line', title: 'Вести звонок без давления', desc: 'Продавать через интерес и диалог, а не через агрессивное навязывание.' },
    { icon: 'ri-arrow-right-circle-line', title: 'Завершать разговор следующим шагом', desc: 'Каждый звонок — это не конец, а начало следующего этапа работы с клиентом.' },
    { icon: 'ri-mental-health-line', title: 'Сохранять уверенность после отказов', desc: 'Психологическая устойчивость, которая позволяет делать следующий звонок так же уверенно, как первый.' },
  ];

  return (
    <section id="skills" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Чему научатся сотрудники после обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Программа даёт не теорию, а практические навыки, которые менеджеры применяют сразу после тренинга в своей ежедневной работе.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {skills.map((skill, i) => (
            <div key={i} className="bg-white rounded-xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all duration-300 text-center group">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${skill.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{skill.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{skill.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}